export default (params) => ({
  trigger: {
    name: 'recommended_accessories.select_alternative_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
        ],
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'recommended_accessories_alternative_overlay',
      },
    },
  },
});
